import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGiftcard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGiftcard"><Path d="M13 4H2V11H11.5858L10.0858 9.5L11.5 8.08579L13 9.58579V4Z" fill="currentColor"/><Path d="M2 13V20H13V14.4142L11.5 15.9142L10.0858 14.5L11.5858 13H2Z" fill="currentColor"/><Path d="M15 20H22V13H16.4142L17.9142 14.5L16.5 15.9142L15 14.4142V20Z" fill="currentColor"/><Path d="M22 11V4H15V9.58579L16.5 8.08579L17.9142 9.5L16.4142 11H22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGiftcard;
